import { render, staticRenderFns } from "./AllocationMenu.vue?vue&type=template&id=4d219231&"
import script from "./AllocationMenu.vue?vue&type=script&lang=js&"
export * from "./AllocationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports